<script lang="ts">
	import type { Post } from '$lib/posts';
	import Tags from '$lib/components/tags.svelte';
	import Time from '$lib/components/time.svelte';

	export let post: Post;
</script>

<article
	class="pl-4 border-l-2 border-transparent hover:border-primary transition-colors duration-200"
>
	<h2>
		<a
			data-sveltekit-reload
			href={post.path}
			class="text-lg font-semibold tracking-tight no-underline hover:text-primary"
			>{post.metadata.title}</a
		>
	</h2>
	<span class="text-sm text-text-secondary leading-relaxed">{post.metadata.headline ?? ''}</span>
	<div class="flex items-center gap-3 mt-1">
		<Time datetime={post.metadata.date} />
		<Tags tags={post.metadata.tags} />
	</div>
</article>
